import Marquee from "react-fast-marquee";

const ITEMS = [
  "Kings County",
  "Consumer Credit",
  "New York County",
  "Debt Buyer Actions",
  "Queens County",
  "Confession of Judgment",
  "Bronx County",
  "Post-Judgment",
  "Richmond County",
  "Mechanic's Lien",
  "Erie County",
  "Foreclosure — Residential",
  "Westchester County",
  "Article 75 Arbitration",
  "Suffolk County",
  "Contract Actions",
  "Nassau County",
  "Landlord & Tenant",
];

export default function MarqueeBand() {
  return (
    <section
      className="border-y border-hairline bg-paper/70 py-6"
      data-testid="county-marquee"
      aria-label="New York counties and case types"
    >
      <Marquee speed={26} gradient gradientColor="#F9F8F6" gradientWidth={140}>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="whitespace-nowrap font-display text-xl text-ink/75 md:text-2xl">{item}</span>
            <span className="mx-10 text-lg text-crimson" aria-hidden="true">§</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
